export default {
  loadSuccess: '加载成功'
}
